export type SidebarChannelId =
  | 'search'
  | 'social'
  | 'tv'
  | 'programmatic'
  | 'audio'
  | 'retail'

export const SIDEBAR_CHANNEL_ORDER: SidebarChannelId[] = [
  'search',
  'social',
  'tv',
  'programmatic',
  'audio',
  'retail',
]

export const DEFAULT_PINNED_SIDEBAR_CHANNELS: SidebarChannelId[] = [
  'search',
  'social',
  'tv',
  'programmatic',
]

export const SIDEBAR_PINNED_CHANNELS_STORAGE_KEY = 'monarch.sidebarPinnedChannels'

export type SidebarChannelDef = {
  id: SidebarChannelId
  label: string
  href: string
  prefetch?: boolean
  activeMatch?: (pathname: string) => boolean
}

export function orderPinnedSidebarChannels(ids: SidebarChannelId[]): SidebarChannelId[] {
  const idSet = new Set(ids)
  return SIDEBAR_CHANNEL_ORDER.filter((id) => idSet.has(id))
}

export function readPinnedSidebarChannels(): SidebarChannelId[] {
  if (typeof window === 'undefined') return DEFAULT_PINNED_SIDEBAR_CHANNELS
  try {
    const raw = localStorage.getItem(SIDEBAR_PINNED_CHANNELS_STORAGE_KEY)
    if (!raw) return DEFAULT_PINNED_SIDEBAR_CHANNELS
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return DEFAULT_PINNED_SIDEBAR_CHANNELS
    const valid = parsed.filter(
      (id): id is SidebarChannelId =>
        typeof id === 'string' && SIDEBAR_CHANNEL_ORDER.includes(id as SidebarChannelId)
    )
    const ordered = orderPinnedSidebarChannels(valid)
    return ordered.length > 0 ? ordered : DEFAULT_PINNED_SIDEBAR_CHANNELS
  } catch {
    return DEFAULT_PINNED_SIDEBAR_CHANNELS
  }
}

export function writePinnedSidebarChannels(pinned: SidebarChannelId[]): void {
  try {
    localStorage.setItem(SIDEBAR_PINNED_CHANNELS_STORAGE_KEY, JSON.stringify(pinned))
  } catch {
    /* ignore */
  }
}
